export default {
  ROLES: {
    ADMIN: "ADMIN",
    USER: "USER",
  },
  ROLE_LABELS: {
    ADMIN: "Admin",
    USER: "User",
  },
  USER_STATUS: {
    ACTIVE: "ACTIVE",
    PENDING: "PENDING",
    SUSPENDED: "SUSPENDED",
  },
  ITEM_STATUS: {
    ACTIVE: "Active",
    INACTIVE: "Inactive",
  },
  VIEW_MODES: {
    LIST: "LIST",
    GRID: "GRID",
  },
  DOMAIN: "KAMINO",
  VERIFY_USER_PAGE_TYPE: "activate",
  CHANGE_PASSWORD_PAGE_TYPE: "change",
  TRANSLATION_MAP: {
    ACTIVE: "user.active-status-label",
    PENDING: "user.pending-status-label",
    SUSPENDED: "user.suspended-status-label",
  },
  BASE_URL: "https://api.test.kamino.mahisoft.com",
  LOCAL_BASE_URL: "http://localhost:4000",
};
